/* eslint-disable no-useless-escape */
/* eslint-disable camelcase */
import React, { useState, useCallback } from 'react';
import Button from './Button';
import { useQuoteById, useQuoteTypeNameByQuoteId } from '../Store/entities/quotes/hooks';
import DiscountReasonModal from '../Modals/DiscountReasonModal';
import { useIsPsAdmin } from '../hooks';
import { useCouponReasonTypes } from '../Store/entities/couponReasonTypes/hooks';

import apiCalls from '../PowerShadesAPIFunctions';
import { UsePortalDispatch } from '../Store';
import { EnsureConnectionMade } from '../Store/signalR/connection';

type CouponInputProps = {
	quoteId: number;
	onCouponChange: (coupons: any) => void;
};

const CouponInput = ({ quoteId, onCouponChange }: CouponInputProps) => {
	const isPsAdmin = useIsPsAdmin();
	const quoteType = useQuoteTypeNameByQuoteId(quoteId);

	const [value, setValue] = useState('');
	const [showDiscountModal, setShowDiscountModal] = useState(false);
	const [isProcessing, setIsProcessing] = useState(false);
	const quote = useQuoteById(quoteId);
	const couponReasonTypes = useCouponReasonTypes();

	const dispatch = UsePortalDispatch();

	const valueChanged = (new_value) => {
		const sanitized = new_value.replace(/[^a-zA-Z0-9\-]/g, '');
		setValue(sanitized.toUpperCase());
	};

	const handleDiscountSubmit = useCallback(async (_reason: string, _couponReasonTypeId: number | null) => {
		if (isProcessing) return;

		setIsProcessing(true);
		try {
			dispatch(EnsureConnectionMade);
			const response = await apiCalls.addCouponToQuote(value, quoteId, false, _reason);
			if (response.status === 200) {
				const couponData = response.data;
				onCouponChange([couponData]);
			}
			setValue('');
			setShowDiscountModal(false);
		} catch (error) {
			console.error('Error applying coupon:', error);
			setShowDiscountModal(false);
			setIsProcessing(false);
		} finally {
			setIsProcessing(false);
		}
	}, [value, quoteId, onCouponChange, dispatch, isProcessing]);

	const handleApplyClick = useCallback(() => {
		const trimmedValue = value.trim();
		if (trimmedValue.length > 0 && !isProcessing) {
			if (isPsAdmin) {
				setShowDiscountModal(true);
			} else {
				handleDiscountSubmit('', null);
			}
		}
	}, [value, isProcessing, isPsAdmin, handleDiscountSubmit]);

	const handleDiscountCancel = useCallback(() => {
		setShowDiscountModal(false);
	}, []);

	return (
		<>
			<div
				style={{
					display: 'flex', height: '22px', fontSize: '11px'
				}}
			>

				<input
					type="text"
					style={{
						fontSize: '1.2em', width: '9em', height: '100%'
					}}
					placeholder="COUPON CODE"
					value={value}
					onChange={(e) => valueChanged(e.target.value)}
					maxLength={30}
				/>

				<Button
					color={quoteType ?? 'green'}
					disabled={isProcessing || !value.trim()}
					style={{
						borderBottomLeftRadius: '0',
						borderTopLeftRadius: '0',
						marginTop: '-1px',
						height: 'calc(100% + 2px)',
						border: '1px solid gray',
						lineHeight: '0',
						fontSize: '1em',
						marginLeft: '-2px',
						letterSpacing: '0px',
						width: '4em',
						padding: '0',
					}}
					onClick={handleApplyClick}
				>
					Apply
				</Button>

				<br />

			</div>

			<DiscountReasonModal
				defaultReason={quote.discount_reason ?? ''}
				open={showDiscountModal}
				onCancel={handleDiscountCancel}
				onSubmit={handleDiscountSubmit}
				quoteType={quoteType}
				couponReasonTypes={couponReasonTypes}
			/>
		</>
	);
};

export default CouponInput;
